// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__f-ALR"};